(() => {
  // Delegation also supports sections re-rendered by the theme editor.
  if (window.drunkdeerDesktopHeroNavigation) return;
  window.drunkdeerDesktopHeroNavigation = true;

  const desktopPointer = window.matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  const selector = 'slide-show[data-desktop-hero-navigation]';
  const controls = '.button, button, input, select, textarea, [role="button"], page-dots';

  function getSlideshow(event) {
    if (!desktopPointer.matches || event.pointerType === 'touch' || !(event.target instanceof Element)) return null;
    return event.target.closest(selector);
  }

  function directionAt(slideshow, clientX) {
    const bounds = slideshow.getBoundingClientRect();
    return clientX < bounds.left + bounds.width / 2 ? 'previous' : 'next';
  }

  document.addEventListener('pointermove', (event) => {
    const slideshow = getSlideshow(event);
    if (!slideshow) return;
    const direction = directionAt(slideshow, event.clientX);
    if (slideshow.dataset.heroDirection !== direction) slideshow.dataset.heroDirection = direction;
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const slideshow = getSlideshow(event);
    // Keep CTA links, pagination, keyboard activation and modified clicks intact.
    if (!slideshow || event.defaultPrevented || event.detail === 0 || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.target.closest(controls)) return;
    const link = event.target.closest('a');
    if (link && !link.classList.contains('slideshow__slide-inner--link')) return;
    const direction = directionAt(slideshow, event.clientX);
    if (typeof slideshow[direction] !== 'function') return;
    // The existing full-slide anchor must not navigate when changing slides.
    event.preventDefault();
    event.stopPropagation();
    if (!slideshow.isTransitioning) slideshow[direction]();
  }, true);
})();
